<script>
import SidebarMenuCollapsed from 'components/ui/menu/sidebar-menu-collapsed';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

export default {
  name: 'sidebar-menu-my-preferences-collapsed',
  mixins: [SidebarMenuCollapsed],
  components: {
    NuttremaIconicaSidebarLink,
  },
  data() {
    return {
      startingUrl: '/professional/settings/instance/',
    };
  },
  methods: {
    isActive(url) {
      return this.$route.path.startsWith(url);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/menu/instance/sidebar-menu-instance-collapsed.vue